import { render } from "./PageWrapperMain.vue?vue&type=template&id=77643454&scoped=true"
import script from "./PageWrapperMain.vue?vue&type=script&lang=js"
export * from "./PageWrapperMain.vue?vue&type=script&lang=js"

import "./PageWrapperMain.vue?vue&type=style&index=0&id=77643454&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77643454"]])

export default __exports__